module.exports = __webpack_public_path__ + "static/brauchtdich_covid-plattform-logo-08c00b1278f780ddbda7d7e580ee1161.png";